import { useEffect } from "react";

import { useModelStore } from "@demo/store/model";

export const SEARCH_TOOLS_QUERY_PARAM = "perceptron-search-tools";

/**
 * Turns the Tools toggle (and Thinking, which search needs) on when the URL carries
 * `?perceptron-search-tools=1`, a shortcut for trying a live Agent harness run. The param stays
 * on the URL so a refresh keeps the flag. Development only; production ignores it.
 */
export const useSearchToolsActivation = (): void => {
  const setEnableReasoning = useModelStore((s) => s.setEnableReasoning);
  const setEnabledTools = useModelStore((s) => s.setEnabledTools);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") return;
    if (new URLSearchParams(window.location.search).get(SEARCH_TOOLS_QUERY_PARAM) !== "1") return;
    setEnableReasoning(true);
    setEnabledTools([...useModelStore.getState().selectedModel.capabilities.tools]);
  }, [setEnableReasoning, setEnabledTools]);
};
